var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Fragment,[_c(_setup.PublicPageMenuEntry,{attrs:{"id":_vm.id,"icon":_vm.icon,"href":"#","label":_vm.label},on:{"click":_setup.openDialog}}),_vm._v(" "),(_setup.showDialog)?_c(_setup.PublicPageMenuExternalDialog,{attrs:{"label":_vm.label}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }